import { LinkBox, LinkOverlay, VStack } from '@chakra-ui/react'

import { CoverImage } from '@!/Store/Common/components/CoverImage'

export const Book = ({ title, contentId, imageUrl, gtmClick, w }) => {
  return (
    <LinkBox w={w}>
      <VStack>
        <CoverImage src={imageUrl} alt={title} objectFit="contain" width={w} />
        <LinkOverlay href={`/store/books/${contentId}`} {...(gtmClick && { 'data-gtm-click': gtmClick })} noOfLines={1} fontSize="sm" fontWeight="bold" w={w}>
          {title}
        </LinkOverlay>
      </VStack>
    </LinkBox>
  )
}
